/* eslint-disable sort-keys */
const breakpoints = {
  MOBILE: "576px",
  TABLET: "768px",
  DESKTOP: "992px",
  XL_DESKTOP: "1200px",
  XXL_DESKTOP: "1400px",
  XS_MOBILE: "360px",
};

export default breakpoints;
